// extracted by mini-css-extract-plugin
export var icon = "_3q-1";
export var subtext = "_3q-0";